import { FormattedMessage } from 'react-intl';

interface ConfirmOpenSlotHintProps {
    show: boolean;
}

/**
 * Short title + subtitle shown above the SPOT layout on confirm-open-SLOT screens.
 */
export const ConfirmOpenSlotHint = ({ show }: ConfirmOpenSlotHintProps) => {
    if (!show) {
        return null;
    }

    return (
        <div className='flex flex-col items-start gap-1 self-stretch'>
            <div className='text-foreground-default text-base font-medium'>
                <FormattedMessage
                    id='kiosk.wizard.confirm-open-slot.select-desired-slot'
                    defaultMessage='Select desired SLOT'
                    description='Title on kiosk wizard confirm-open-SLOT layout screens prompting the user to select a SLOT'
                />
            </div>
            <div className='text-brand-muted self-stretch text-base font-medium'>
                <FormattedMessage
                    id='kiosk.wizard.confirm-open-slot.click-open-slot'
                    defaultMessage="Click 'open SLOT' to continue"
                    description='Subtitle on kiosk wizard confirm-open-SLOT layout screens pointing users to the Open SLOT footer button'
                />
            </div>
        </div>
    );
};
